import { type ExpertDomain } from '../../../../types/domain/expert-domain'
import { capitalize } from '../../../../utils/capitalize'
import { formatDate } from '../../../../utils/date'
import { getYesOrNoTextByBoolean } from '../../../../utils/getYesOrNoTextByBoolean'

const handleProactive = (proactive: string | null | undefined) => {
  if (proactive === 'yesSearch') return 'Sim, pesquisa'
  if (proactive === 'yesOffer') return 'Sim, oferta'
  if (proactive === 'no') return 'Não'
  return null
}

export const mapExpertDomainDataToTableRow = ({
  id,
  name,
  email,
  createdAt,
  professionalData,
  bankData,
  linkedin,
  naturalData,
  researcher,
  recruiterName,
  phone,
  bio,
  cpf,
  observations,
  lastContactAt,
  agreeParticipateMeet,
  doNotContactTemporarily,
  acceptedAt,
  meetingLanguages,
  nationality,
  bankCountry,
  howDiscoverUs,
}: ExpertDomain) => ({
  id,
  name,
  email,
  phone,
  bio,
  cpf,
  meetingLanguages: meetingLanguages?.join(', '),
  nationality: nationality ? capitalize(nationality) : '',
  bankCountry: bankCountry ? capitalize(bankCountry) : '',
  date: formatDate(new Date(createdAt)),
  acceptedAt: acceptedAt ? formatDate(new Date(acceptedAt)) : acceptedAt,
  previousCompany: professionalData?.previousCompany,
  currentCompany: professionalData?.currentCompany,
  position: professionalData?.position,
  sector: professionalData?.sector,
  subsector: professionalData?.subsector,
  area: professionalData?.area,
  linkedin,
  cep: naturalData?.cep,
  value: new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: professionalData?.currency
      ? `${professionalData?.currency}`
      : 'BRL',
  }).format(
    Number(
      typeof professionalData?.value === 'string' && professionalData?.value
    )
  ),
  researcher: researcher?.name ?? recruiterName,
  blind: getYesOrNoTextByBoolean(professionalData?.blind),
  smallGroup:
    professionalData?.smallGroup === 'moreThan5'
      ? 'Mais de 5'
      : professionalData?.smallGroup,
  proactive: handleProactive(professionalData?.proactive),
  bank: bankData?.bank,
  currentAccount: bankData?.currentAccount,
  bankBranch: bankData?.bankBranch,
  rg: naturalData?.rg,
  birthDate: naturalData?.birthdate,
  street: naturalData?.street,
  addressNumber: naturalData?.addressNumber,
  neighborhood: naturalData?.neighborhood,
  city: naturalData?.city,
  state: naturalData?.state,
  ra: researcher?.name ?? recruiterName,
  observations,
  lastContactAt,
  agreeParticipateMeet: getYesOrNoTextByBoolean(agreeParticipateMeet),
  doNotContactTemporarily: getYesOrNoTextByBoolean(doNotContactTemporarily),
  howDiscoverUs,
})
